import "core-js/modules/es.object.assign.js";
export function shallowCopyObjectTo(from, to) {
  if (!from) return;
  for (var k in from) {
    to[k] = from[k];
  }
}
export function isEmptyObject(obj) {
  return !obj || !Object.keys(obj).length;
}
/**
 * Makes the deep copy of the input object.
 * For performance purposes, if the values of the properties of the object to copy are all primitive types then we will use the spread operator (faster).
 * Otherwise, to ensure the deep copy of nested objects and arrays, we will use JSON.parse and JSON.stringify (slower).
 * */
export function deepCopy(objToCopy) {
  if (!objToCopy) return null;
  for (var key in objToCopy) {
    var prop = objToCopy[key];
    if (!prop) continue;
    //Sebastian R.S: If the property value is a primitive type, then we will continue!
    if (Array.isArray(prop) || Object.keys(prop).length > 0) {
      return JSON.parse(JSON.stringify(objToCopy));
    }
  }
  return Object.assign({}, objToCopy);
}
export var insertEntry = (obj, k, v) => {
  if (!obj) obj = {
    [k]: v
  };else obj[k] = v;
};
export var getOrNull = v => v ? v : null;